import styled from 'styled-components';

import { Color, ZIndex } from '../../../enums';
import { StyledComponent } from '../../../interfaces';

export const InfoText: StyledComponent<'div'> = styled.div`
  background-color: ${Color.Error500};
  font-size: 12px;
  line-height: 16px;
  color: ${Color.White};
  opacity: 0;
  pointer-events: none;
  transition: 0.3s;
  padding: 10px 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  position: absolute;
  bottom: 30px;
  left: 50%;
  z-index: ${ZIndex.Tooltip};
  transform: translateX(-50%);
  :after {
    border-left: solid ${Color.Transparent} 8px;
    border-right: solid ${Color.Transparent} 8px;
    border-top: solid ${Color.Error500} 6px;
    bottom: -6px;
    content: ' ';
    height: 0;
    left: 50%;
    transform: translateX(-50%);
    position: absolute;
    width: 0;
  }
`;
